import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Organization User Management Services
 * !== 기관 사용자 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/orgusr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/org-usr-mgmt`,
    nodes: [],
};

export const URLS = {
    ptli0917001q: `${BASE.path}/ptli0917001q`, // Organization User List !==  기관 사용자 목록 ==!
    ptli0917002s: `${BASE.path}/ptli0917002s`, // Organization User Registration !==  기관 사용자  등록 ==!
    ptli0917003s: `${BASE.path}/ptli0917003s`, // Modifying and deleting Organization User!==  기관 사용자 수정 및 삭제 ==!
    ptli0917004q: `${BASE.path}/ptli0917004q`, // Organization User Detail !==  기관 사용자 상세 ==!
};

export const APIS = {
    // Check Organization User List !==  기관 사용자 목록 조회 ==!
    getOrgUsrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Check Organization User information !==  기관 사용자 정보 조회 ==!
    getOrgUsrInfo: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },
    // Create Organization User information !==  기관 사용자 정보 등록 ==!
    createOrgUsrInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // update Organization information !==  기관 정보 수정 ==!
    updateOrgUsrInfo: (data: any) => {
        return api.put(`${BASE.api}`, { ...data });
    },
    //delete Organization User information !== 기관 사용자 정보 삭제 ==!
    deleteOrgUsrInfo: (xtrnUsrUuid: any) => {
        return api.delete(`${BASE.api}/${xtrnUsrUuid}`);
    },

    // Execute Organization User Approval !== 기관 사용자 승인 ==!
    executeUsrAprv: (data: any) => {
        return api.put(`${BASE.api}/aply`, {
            ...data,
        });
    },

    // !== 기관 사용자 반려 ==!
    executeUsrRtrn: (data: any) => {
        return api.put(`${BASE.api}/aply`, {
            ...data,
        });
    },

    // !== 기관 사용자 비밀번호를 초기화한다. ==!
    updateOrgUsrPwdInit: (data: any) => {
        return api.put(`${BASE.api}/pwd-init`, {
            ...data,
        });
    },

    getPayerTinNoLst: (tinNo: any, bizYn: any) => {
        return comnUtils.getCode({
            area: "payerTinNo",
            keyword: tinNo,
            param2: bizYn,
        });
    },

    /*
    getTinNoLst: (tinNo: any, bizYn: any) => {
        return comnUtils.getCode({
            area: "tinNo",
            keyword: tinNo,
            param2: bizYn,
        });
    },
    */

    // User duplicate check !== 사용자 중복 체크 ==!
    getUsrDuplCheck: (xtrnUsrIdntfNo: any) => {
        return api.put(`${BASE.api}/getUsrDuplCheck`, { xtrnUsrIdntfNo: xtrnUsrIdntfNo });
    },
};

export const SF_ORG_USR_SRCH: TFormSchema = {
    id: "form_orgSrch",
    schema: {
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md" },
        usrNm: { type: "text", label: "L_USR_NM" },
        psnTin: { type: "text", label: "L_TIN" },
        usrStatCd: { type: "select", label: "L_STAT", all: true, area: "comnCd", comnCd: "PTL0001" },
        orgRppnYn: {
            type: "select",
            label: "L_ORG_RPPN_YN",
            options: [
                { label: "Head of Organazation", value: "Y" },
                { label: "General", value: "N" },
            ],
        },
    },
};

export const SF_ORG_USR_INFO: TFormSchema = {
    id: "form_orgInfo",
    schema: {
        psnTin: { type: "text", label: "L_TIN", required: true },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md", required: true },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "Y" },
                { label: "Foreigner", value: "N" },
            ],
            defaultValue: "N",
            required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", required: true },
        usrNm: { type: "text", label: "L_USR_NM", required: true },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", required: true },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.com.00110" },
            required: true,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", required: true },
        usrPwd: {
            type: "password",
            label: "L_USR_PWD",
            required: true,
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "비밀번호는 10자 이상이어야 하며, 대문자, 소문자, 숫자, 특수문자를 포함해야 합니다",
            },
        },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM", required: true },
        preXtrnUsrAplyId: { type: "text" },
        usrStatCd: { type: "select", label: "L_STAT", all: false, area: "comnCd", comnCd: "PTL0001", required: true },
        deptCd: { type: "code", label: "L_ORG_DEPT", area: "orgDeptCd", popupSize: "md" },
        orgRppnYn: {
            type: "radio",
            label: "L_ORG_RPPN_YN",
            options: [
                { label: "Head of Organazation", value: "Y" },
                { label: "General", value: "N" },
            ],
            edit: true,
        },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000 },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                // dclrYn: "Y",
            },
        },
    },
};

export const SG_ORG_USR_LIST: TGridSchema = {
    id: "grid_orgList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "psnTin", width: "10%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_ORG_NM", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_ORG_RPPN_YN", binding: "orgRppnYn", width: "15%" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "psnTin" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "orgNm", align: "left" }],
        },
        {
            cells: [
                {
                    binding: "orgRppnYn",
                    align: "left",
                    type: "radio",
                    options: [
                        { label: "Head of Organazation", value: "Y" },
                        { label: "General", value: "N" },
                    ],
                },
            ],
        },
        {
            cells: [{ binding: "usrStatCdNm" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};

// Customs Office Code is a mandatory field for ORG(TBS, ZBS, WMA) !== TBS, ZBS, WMA 기관은 세관 사무소 코드 필수 입력 ==!
export const CSTM_OFCE_CD_RQRD_ARR = new Array("OGAM0001", "OGAM0035", "OGAZ0001");
